module.exports = __webpack_public_path__ + "static/img/buycars.eae050f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/buycars.gif
// module id = MAlg
// module chunks = 0